import { render } from "./landscape.vue?vue&type=template&id=888e48ca&scoped=true"
import script from "./landscape.vue?vue&type=script&lang=js"
export * from "./landscape.vue?vue&type=script&lang=js"

import "./landscape.vue?vue&type=style&index=0&id=888e48ca&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-888e48ca"]])

export default __exports__